const gridOptions = {
  onRowClicked(event) {
    //   event.preventDefault();
    console.log("The row was clicked.");
  }
};

export default gridOptions;
